import { render, staticRenderFns } from "./GatherContactInformation.vue?vue&type=template&id=bef49cd0"
import script from "./GatherContactInformation.vue?vue&type=script&lang=js"
export * from "./GatherContactInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports